import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

type Props = {
    filters: React.ReactNode;
    children: React.ReactNode;
};

/**
 * This is the layout for a report. It puts the filters in a toolbar at the
 * top, and the main content below.
 *
 * Okay, well, for now, this is really just a pretty silly component: all it
 * really does is add a spacing element between the two children provided. But
 * we just have *so many* report call sites, and streamlining them by removing
 * layout concerns is just such a win, even if the only *concrete* piece of
 * layout is a spacing element.
 */
function ReportLayout({filters, children}: Props): React.ReactElement {
    return (
        <View>
            <View>{filters}</View>
            <Strut size={spacing.large_24} />
            <View>{children}</View>
        </View>
    );
}

export default ReportLayout;
